export interface GouvDvfMutationDto {
  id_mutation?: string;
  date_mutation?: string;
  nature_mutation?: string;
  valeur_fonciere?: number;
  type_local?: string;
  surface_reelle_bati?: number;
  nombre_pieces_principales?: number;
  code_postal?: string;
  nom_commune?: string;
  price_m2?: number;
}

export class GouvDvfDataDto {
  medianPriceM2!: number;
  averagePriceM2?: number;
  minPriceM2!: number;
  maxPriceM2!: number;
  salesCount!: number;
  propertyType!: string;
  sectionCode?: string;
  codeInsee?: string;
  fetchedAt?: Date;
  recentSales?: GouvDvfMutationDto[];
}
